export enum CustomerContactRole {
  BUYER = 'buyer',
  RECEIVING = 'receiving'
}

export const getRoleName = (role: CustomerContactRole): string => {
  switch (role) {
    case CustomerContactRole.BUYER:
      return "Buyer";
    case CustomerContactRole.RECEIVING:
      return "Receiving";
    default:
      return "Unknown";
  }
};

export default interface CustomerContact {
  id: number;
  role: CustomerContactRole;
  name: string;
  email: string;
  phone: string;
  altPhone: string;
  altEmail: string;
  /** Empty when no card is on file. */
  creditCardLast4?: string;
  customerId: number;
}

export interface CreditCardInfo {
  number: string;
  /** MM/YY */
  expiration: string;
  cvv: string;
  zip: string;
  nameOnCard: string;
}
